import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  Typography,
  useMediaQuery,
  TextField,
  useTheme,
  Radio,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { Edit, Info } from "@mui/icons-material";
import { Field, reduxForm } from "redux-form";
import { homeActions } from "actions";
import { renderCustomTextField } from "components/FormFields/FieldTypes";
import { zip as zipNormalizer } from "components/FormFields/normalizers";
import { zip as zipValidator } from "components/FormFields/validators";
import MainTemplateHeader from "components/MainTemplateHeader";
import { v4 as uuidv4 } from "uuid";
import ZipcodeErrorMsg from "./ZipcodeErrorMsg";

const ProductDetailsView = (props) => {
  const theme = useTheme();
  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const {
    match,
    productDetails,
    selectedInsurance,
    resetData,
    saveInsuranceData,
    saveQuantity,
    saveDosage,
    saveForm,
    getCityStateForZipCode,
    openInsurance,
    zipInputRef,
    zipData,
    onDetailsLoad,
    selectedProduct,
    saveZipCodeToServer,
    updateGTMDataLayer,
    insuranceRef,
    currentLocation,
    showAlternatives,
    setGaugeInit,
    gaugeInit,
    openSearchButton,
    setOpenSearchButton,
    saveUserInsurance,
    setSavingsBtnAutoForward,
    setShowGauge,
    editFromInsurace,
    setEditFromInsurace,
    hasUserSelectedInsurance,
    copayPrice,
    organizationInfo,
    genericDetails,
    brandDetailsNew,
    retailDataError,
    retailDataIsSuccess,
    retailDataisProgress,
    discountPriceError,
    discountPriceIsSucces,
    discountPriceisProgress,
  } = props;

  console.log("hasUserSelectedInsurance", hasUserSelectedInsurance);

  const [formValue, setFormValue] = useState(0);
  const [quantityValue, setQuantityValue] = useState(0);
  const [quantityObj, setQuantityObj] = useState({});
  const [dosageValue, setDosageValue] = useState(0);

  const [showRetailError, setShowRetailError] = useState(false);
  const [showDiscountError, setShowDiscountError] = useState(false);
  const [showCustomQuantity, setShowCustomQuantity] = useState(false);
  const [formType, setFormType] = useState([]);
  const [dosageTypes, setDosageTypes] = useState([]);
  const [dosageTypeVal, setDosageTypeVal] = useState("");
  const [quantityTypes, setQuantityTypes] = useState([]);
  const [customQuantity, setCustomQuantity] = useState("");
  const [localReset, setLocalReset] = useState(uuidv4());

  let storedZipData = JSON.parse(localStorage.getItem("storedZipData"));
  const storedInsuranceData = JSON.parse(
    localStorage.getItem("storedInsuranceData")
  );

  // const hasUserSelectedInsurance = localStorage.getItem(
  //   "hasUserSelectedInsurance"
  // );

  //  const defaultInsuranceId = localStorage.getItem("defaultInsuranceId");

  const [openZipCodeUpdateDialog, setZipCodeUpdateDialog] = useState(false);

  let locType = localStorage.getItem("zip_location_type");

  const [locationType, setlocationType] = React.useState(locType);
  const [locationTypeTemp, setLocationTypeTemp] = React.useState(locType);
  const [searchButton, setSearchButton] = React.useState(true);
  const [tempFormValue, setTempFormValue] = React.useState({});
  const [zipCodeChange, setZipCodeChange] = React.useState(false);
  const [insuraceChange, setInsuraceChange] = React.useState(false);
  const [gaugeReset, setGaugeReset] = React.useState(false);
  // const [openSearchButton, setOpenSearchButton] = React.useState(false);

  const [urlProductDetailId, setUrlProductDetailId] = useState(null);
  const [urlQuantity, setUrlQuantity] = useState(null);

  const showProductDetailSelectionFlag =
    organizationInfo?.organizationOptionJson?.showProductDetailSelectionFlag?.toLowerCase() ===
    "y";
  useEffect(() => {
    if (match?.params?.urlProductDetailId) {
      setUrlProductDetailId(match?.params?.urlProductDetailId);
    }
    if (match?.params?.urlQuantity) {
      setUrlQuantity(match?.params?.urlQuantity);
    }
  }, [match?.params]);

  const radioBtnHandleChange = (event) => {
    setLocationTypeTemp(event.target.value);
  };
  const radioControlProps = (item) => ({
    checked: locationTypeTemp === item,
    onChange: radioBtnHandleChange,
    value: item,
    name: "location-type-radio-button",
    inputProps: { "aria-label": item },
  });

  const resetForm = (event) => {
    formOptionChange(event, { props: { value: tempFormValue.form } });
    dosageChange(event, { props: { value: tempFormValue.dosage } });
    quantityChange(
      {
        target: { value: tempFormValue.quantity.productDetailId },
      },
      "reset"
    );

    if (insuraceChange) {
      if (tempFormValue?.insurance?.type === "Z") {
        clearCommercialInsurance();
      }
      getSelectedOption(null, tempFormValue.insurance);
      setInsuraceChange(false);
    }
    if (zipCodeChange) {
      storedZipData = tempFormValue.storedZipData;
      localStorage.setItem(
        "storedZipData",
        JSON.stringify(tempFormValue.storedZipData)
      );

      setlocationType(tempFormValue.locationType);
      setLocationTypeTemp(tempFormValue.locationType);

      if (tempFormValue.locationType === "manual") {
        setStoredLocation(true);
      } else if (tempFormValue.locationType === "current_location") {
        setCurrentLocation();
      }

      let zipCode = storedZipData?.zipCode;
      if (tempFormValue.locationType === "current_location") {
        zipCode = `${currentLocation?.locality}, ${currentLocation?.administrative_area}`;
      }

      props.initialize({
        zipCode: zipCode,
      });

      setZipCodeChange(false);
    }
  };

  const storeFormValues = () => {
    let obj = {
      form: formValue,
      dosage: dosageValue,
      quantity: quantityObj,
      insurance: selectedInsurance,
      locationType: locationType,
      storedZipData: storedZipData,
    };
    setTempFormValue(obj);
    console.log(obj);
  };

  useEffect(() => {
    if (openSearchButton) {
      storeFormValues();
    }
  }, [openSearchButton]);

  const clearCommercialInsurance = () => {
    localStorage.setItem("commercialInsuranceValue", "");
    localStorage.setItem("isCommercialInsuranceValueUpdated", "");
  };

  const getSelectedOption = (event, item) => {
    const isInsured = selectedInsurance;
    if (item.displayText) {
      item.name = item.displayText;
      item.id = item.value.id;
      item.type = item.value.type;
    }
    if (item) {
      saveInsuranceData(item);
      saveUserInsurance(item.id);
    }
    if (isInsured && (isInsured?.id || isInsured?.type === "Z") && item) {
      // resetData("insuranceReset");
    }

    updateGTMDataLayer({
      event: "Search_medication_select_insurance",
      insurance_type: "",
      insurance: item.name || "",
      page: "Search for medication",
      screen: "Select Insurance",
      screen_referrer: "Search for medication",
    });
  };

  useEffect(() => {
    if (storedInsuranceData && productDetails.length) {
      // resetData("quantityReset");
      setSearchButton(false);
    }
    if (selectedInsurance && !gaugeInit && !openSearchButton) {
      setSearchButton(true);
      // setGaugeInit(true);
    } else if (selectedInsurance && !gaugeInit && openSearchButton) {
      setSearchButton(false);
      setInsuraceChange(true);
    }
  }, [selectedInsurance]);

  const setCurrentLocation = () => {
    if (
      currentLocation !== null &&
      showProductDetailSelectionFlag &&
      zipData?.zipCode
    ) {
      // saveCurrentLocationData({ data: currentLocation, success: true });
      const currentLocationStr = `${currentLocation?.locality}, ${currentLocation?.administrative_area}`;
      props.initialize({
        zipCode:
          locationType === "current_location"
            ? currentLocationStr
            : currentLocation.zipcode,
      });
      // if (
      //   !currentLocation?.zipCode ||
      //   currentLocation?.zipCode !== storedZipData?.zipCode
      // ) {
      //   savedevicelocation(currentLocation);
      // }
      // getCityStateForZipCode(currentLocation.zipcode);
      onDetailsLoad("reload");
      updateGTMDataLayer({
        page: "Search for medication",
        screen: "Search for medication",
        medication_name: selectedProduct?.productName,
        insurance: storedInsuranceData?.name,
        event: "Search_medication_zipcode",
        zipcode: currentLocation.zipcode,
      });
    }
  };

  const setStoredLocation = (validate = false) => {
    if (storedZipData && showProductDetailSelectionFlag) {
      props.initialize({
        zipCode: storedZipData.zipCode,
      });
      if (validate) {
        getCityStateForZipCode(storedZipData.zipCode);
      }

      if (zipData && Object.keys(zipData).length === 0) {
        onDetailsLoad("isInitial");
      } else {
        onDetailsLoad("reload");
      }
      updateGTMDataLayer({
        page: "Search for medication",
        screen: "Search for medication",
        medication_name: selectedProduct?.productName,
        insurance: storedInsuranceData?.name,
        event: "Search_medication_zipcode",
        zipcode: storedZipData.zipCode,
      });
    }
  };

  useEffect(() => {
    if (locationType === "manual") {
      setStoredLocation();
    } else if (locationType === "current_location" && currentLocation) {
      setCurrentLocation();
    }
  }, [locationType, currentLocation, zipData?.zipCode]);

  useEffect(() => {
    if (!locationType && locType) {
      setlocationType(locType);
      setLocationTypeTemp(locType);
    }

    if (productDetails.length && !locationType) {
      if (currentLocation) {
        locType = "current_location";
      } else {
        locType = "manual";
      }

      setlocationType(locType);
      setLocationTypeTemp(locType);
      localStorage.setItem("zip_location_type", locType);
    }
  }, [productDetails]);

  useEffect(() => {
    if (quantityValue) {
      updateGTMDataLayer({
        event: "Search_medication_quantity_select",
        med_form: formValue,
        med_dosage: dosageValue,
        med_quantity: quantityValue,
      });
    }
  }, [quantityValue]);

  useEffect(() => {
    if (dosageValue) {
      updateGTMDataLayer({
        event: "Search_medication_dosage_select",
        med_form: formValue,
        med_dosage: dosageValue,
        med_quantity: quantityValue,
      });
    }
  }, [dosageValue]);

  useEffect(() => {
    updateGTMDataLayer({
      event: "Search_medication_form_select",
      med_form: formValue,
      med_dosage: dosageValue,
      med_quantity: quantityValue,
    });
  }, [formValue]);

  useEffect(() => {
    if (retailDataIsSuccess && !retailDataisProgress) {
      setShowRetailError(false);
    }

    if (
      retailDataError !== null &&
      retailDataError?.message &&
      retailDataError?.data === null &&
      !retailDataIsSuccess &&
      !retailDataisProgress
    ) {
      setShowRetailError(true);
    }
  }, [retailDataError, retailDataIsSuccess, retailDataisProgress]);

  useEffect(() => {
    if (discountPriceIsSucces && !discountPriceisProgress) {
      setShowDiscountError(false);
    }
    if (
      discountPriceError !== null &&
      discountPriceError?.message &&
      discountPriceError?.data === null &&
      !discountPriceIsSucces &&
      !discountPriceisProgress
    ) {
      setShowDiscountError(true);
    }
  }, [discountPriceError, discountPriceIsSucces, discountPriceisProgress]);

  useEffect(() => {
    if (
      zipData &&
      zipData.zipCode &&
      locationType === "manual" &&
      selectedProduct &&
      zipInputRef?.current?.value
    ) {
      saveZipCodeToServer(zipData?.zipCode);
    }
  }, [zipData?.zipCode]);

  useEffect(() => {
    if (selectedProduct) {
      setFormType([]);
      setDosageTypes([]);
      setQuantityTypes([]);
      setFormValue("");
      saveForm("");
      setDosageValue("");
      saveDosage("");
      setQuantityValue("");
      setQuantityObj({});
      // updateGTMDataLayer({
      //   medication_name: selectedProduct?.productName,
      // });
    }
  }, [selectedProduct]);

  const defaultProductDetail = () => {
    if (productDetails && productDetails.length) {
      let defaultForm = productDetails.filter((j) => j.defaultFlag === "Y");
      let initialFormValue = defaultForm.length
        ? defaultForm[0]
        : productDetails[0];
      if (!defaultForm.length) {
        productDetails.forEach((item) => {
          const dosage = item.data.filter((k) => k.defaultFlag === "Y");
          if (!dosage.length) {
            item.data.forEach((secondItem) => {
              const result = secondItem.data.filter(
                (p) => p.defaultFlag === "Y"
              );
              if (result.length) {
                initialFormValue = item;
              }
            });
          } else {
            initialFormValue = item;
          }
        });
      }
      setFormValue(initialFormValue.form);
      saveForm(initialFormValue.form);
      setFormType(productDetails);
      setCustomQuantity("");
      setDosageTypeVal(
        productDetails[0]?.dosageType ? productDetails[0]?.dosageType : ""
      );
    }
  };
  const defaultFormValue = () => {
    if (productDetails && productDetails.length && formValue) {
      const doses = productDetails.filter((x) => x.form === formValue)[0];
      const dosesOptions = doses.data;
      const defaultDose = doses.data.filter((j) => j.defaultFlag === "Y");
      let initialDoseValue = defaultDose.length
        ? defaultDose[0]
        : doses.data[0];
      if (!defaultDose.length) {
        let matchingStarted = true;
        doses.data.forEach((item) => {
          const resultQuantity = item.data.filter(
            (fun) => fun.defaultFlag === "Y"
          );
          if (resultQuantity.length && matchingStarted) {
            initialDoseValue = item;
            matchingStarted = false;
          }
        });
      }
      setDosageTypes(dosesOptions);
      setDosageValue(initialDoseValue?.dosage);
      saveDosage(initialDoseValue?.dosage);
      setLocalReset(uuidv4());
    }
  };
  const defaultDosageValue = () => {
    if (productDetails && productDetails.length && dosageValue) {
      const formTypes = productDetails.filter((x) => x.form === formValue)[0];
      const dosages = formTypes.data.filter((y) => y.dosage === dosageValue)[0];
      let quantityOfValue = dosages.data[0];
      const filteredQty = dosages.data.filter(
        (value) => value.defaultFlag === "Y"
      );
      if (filteredQty?.length) {
        quantityOfValue = filteredQty[0];
      }
      setQuantityTypes(dosages.data);
      setQuantityValue(quantityOfValue.productDetailId);
      setQuantityObj(quantityOfValue);
      saveQuantity(quantityOfValue);
      setDosageTypeVal(formTypes.dosageType);
      if (gaugeInit) {
        resetData("quantityReset");
      }
    }
  };

  // Search for ProductDetailId
  // Check if the Custom Quantity flag = 'Y' and quantity != 99999 then take the quantity as part of the element
  // Check if the Custom Quantity flag = 'Y' and quantity = 99999 then take the quantity from the url
  // if the custom quantity flag = 'N' and quantity given in the URL ignore the quantity in the url but use the quantity from the element
  // If all of the above conditions fail, just default to the default flag product detail id
  // If the drug name did not return any matching products, then go back to home page

  const findDefaultProductDetailByUrlValues = () => {
    let data = {};
    productDetails?.filter((item) => {
      item?.data.forEach((item1) => {
        item1?.data.forEach((item2) => {
          if (item2?.productDetailId == urlProductDetailId) {
            // Quantity flag = 'Y' or 'N', use the quantity from the element
            let item2Data = item2;

            // Quantity flag = 'Y' &&  quantity = 99999 then take the quantity from the url
            if (
              item2?.customQtyFlag?.toLocaleLowerCase() === "y" &&
              Number(item2?.quantity) === 99999 &&
              Number(urlQuantity)
            ) {
              item2Data = { ...item2, quantity: Number(urlQuantity) };
            }

            data = { item, item1, item2: item2Data };
          }
        });
      });
    });

    if (!data?.item2) {
      setUrlProductDetailId(null);
      setUrlQuantity(null);
      defaultProductDetail();
    }

    if (data?.item && data?.item1 && data?.item2) {
      const initialFormValue = data?.item;
      setFormValue(initialFormValue?.form);
      saveForm(initialFormValue?.form);
      setFormType(productDetails);
      setCustomQuantity("");
      setDosageTypeVal(initialFormValue?.dosageType);
      if (data?.item1) {
        const initialDoseValue = data?.item1;
        setDosageTypes(initialFormValue?.data);
        setDosageValue(initialDoseValue?.dosage);
        saveDosage(initialDoseValue?.dosage);
        setLocalReset(uuidv4());
        if (data?.item2) {
          const quantityOfValue = data?.item2;
          setQuantityTypes(initialDoseValue?.data);
          setQuantityValue(quantityOfValue.productDetailId);
          setQuantityObj(quantityOfValue);
          saveQuantity(quantityOfValue);
          setDosageTypeVal(initialFormValue?.dosageType);
          if (gaugeInit) {
            resetData("quantityReset");
          }
        }
      }
    }
  };

  useEffect(() => {
    if (
      productDetails &&
      productDetails.length &&
      urlProductDetailId &&
      urlQuantity
    ) {
      findDefaultProductDetailByUrlValues();
    } else if (productDetails && productDetails.length) {
      defaultProductDetail();
    }
  }, [productDetails]);

  useEffect(() => {
    if (
      productDetails &&
      productDetails.length &&
      formValue &&
      !urlProductDetailId &&
      !urlQuantity
    ) {
      defaultFormValue();
    }
  }, [formValue]);

  useEffect(() => {
    if (
      productDetails &&
      productDetails.length &&
      dosageValue &&
      !urlProductDetailId &&
      !urlQuantity
    ) {
      defaultDosageValue();
    }
  }, [dosageValue, localReset]);

  useEffect(() => {
    saveDosage(dosageValue);
    saveForm(formValue);
    saveQuantity(quantityObj);
  }, [showAlternatives]);

  const formOptionChange = (event, option) => {
    if (option && option.props) {
      setFormValue(option.props.value);
      saveForm(option.props.value);
      setSearchButton(false);
      setGaugeReset(true);
    }
  };

  const dosageChange = (event, option) => {
    if (option && option.props) {
      setDosageValue(option.props.value);
      saveDosage(option.props.value);
      setSearchButton(false);
      setGaugeReset(true);
    }
  };

  const quantityChange = (event, clickElm = "select") => {
    const qtySelected = quantityTypes.filter(
      (item) => item.productDetailId === event.target.value
    )[0];
    setSearchButton(false);
    if (
      clickElm !== "reset" &&
      (qtySelected.quantity === 99999 || qtySelected.isCustomQuantity)
    ) {
      setShowCustomQuantity(true);
    } else if (qtySelected && Object.keys(qtySelected).length) {
      setQuantityValue(qtySelected.productDetailId);
      setQuantityObj(qtySelected);
      saveQuantity(qtySelected);
      setGaugeReset(true);
      // resetData("quantityReset");
    }
  };

  const onEnterCustomValue = () => {
    const matchedElement = quantityTypes.filter(
      (QType) => QType.quantity === parseFloat(customQuantity)
    );
    if (!matchedElement.length) {
      let enteredQuantity = {};
      const d1 = quantityTypes.map((item) => {
        if (item.quantity === 99999 || item.isCustomQuantity) {
          enteredQuantity = {
            ...item,
            quantity: customQuantity,
            isCustomQuantity: true,
          };
          return enteredQuantity;
        } else {
          return item;
        }
      });
      setQuantityTypes(d1);
      setQuantityValue(enteredQuantity.productDetailId);
      setQuantityObj(enteredQuantity);
      saveQuantity(enteredQuantity);
    } else {
      setCustomQuantity("");
      const d2 = quantityTypes.map((item) => {
        if (item.isCustomQuantity) {
          return {
            ...item,
            quantity: 99999,
          };
        } else {
          return item;
        }
      });
      setQuantityTypes(d2);
      setQuantityValue(matchedElement[0].productDetailId);
      setQuantityObj(matchedElement[0]);
      saveQuantity(matchedElement[0]);
    }
    // resetData("quantityReset");
    setGaugeReset(true);
    setShowCustomQuantity(false);
  };

  const zipSearch = (event) => {
    if (event?.target?.value && event.target.value.length === 5) {
      setSearchButton(false);
      setZipCodeChange(true);
      setGaugeReset(true);
      getCityStateForZipCode(event.target.value);
      onDetailsLoad("reload");
      document.getElementById("appcontent").scroll(0, 0);
    }
  };

  const getMin = (a, b) => {
    console.log("getMin", a, b);
    if (a < b) {
      console.log("getMin", a);
      return a;
    }
    console.log("getMin", b);
    return b;
  };

  const getMax = (a, b) => {
    console.log("getMax", a, b);
    if (a > b) {
      console.log("getMax", a);
      return a;
    }
    console.log("getMax", b);
    return b;
  };

  return (
    <Box px={matchesMinWidth ? 3 : 8} sx={{ backgroundColor: "#fff" }}>
      {showProductDetailSelectionFlag ? (
        <form>
          <Grid sx={{ alignItems: "baseline" }} container>
            {openSearchButton && (
              <>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingTop: "1%",
                  }}
                >
                  <MainTemplateHeader
                    fromModifyScreen={true}
                    title={selectedProduct?.productName}
                  />
                </Grid>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    paddingTop: "3%",
                  }}
                >
                  <Typography variant="h1LatoHeavy"> Modify Search</Typography>
                </Grid>
              </>
            )}

            {hasUserSelectedInsurance === "N" &&
              !openSearchButton &&
              (copayPrice?.alternateFlag === "Y" ||
                selectedProduct.type === "G") && (
                <Grid
                  item
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: matchesMinWidth ? "3%" : "2%",
                    "padding-bottom": matchesMinWidth ? "3%" : "0%",
                  }}
                  xs={12}
                  sm={12}
                  py={matchesMinWidth ? 1.5 : 4}
                  px={matchesMinWidth ? 1 : 4}
                >
                  <Button
                    // disabled={gaugeInit}
                    variant="largeOutline"
                    id="getSavingsBtn"
                    onClick={() => {
                      // setGaugeInit(false);
                      // setOpenSearchButton(true);
                      // setSavingsBtnAutoForward(false);
                      openInsurance("select_insurance");
                      //document.getElementById("appcontent").scroll(0, 0);
                    }}
                    style={{
                      minWidth: matchesMinWidth ? "280px" : undefined,
                      // backgroundColor:
                      //   gaugeInit || searchButton ? "#fff" : "#83d712",
                    }}
                  >
                    Select Insurance to compare to copay
                  </Button>
                </Grid>
              )}

            <Grid
              sx={{ padding: "3%" }}
              item
              xs={4}
              sm={4}
              id="formField"
              py={matchesMinWidth ? 1.5 : 4}
              px={matchesMinWidth ? 1 : 4}
            >
              <FormControl variant="standard" sx={{ width: "100%" }}>
                <InputLabel
                  sx={{
                    "-webkit-transform": " translate(0, -1.5px) scale(0.75)",
                  }}
                >
                  <Typography variant="h1LatoMedium">Form</Typography>
                </InputLabel>
                {!openSearchButton && (
                  <Typography
                    component={"div"}
                    variant="h1LatoSemiBold"
                    eleme
                    sx={{
                      height: matchesMinWidth ? "27px" : undefined,
                      marginTop: "24px",
                      color: "#083d4c",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      width: matchesMinWidth ? "94%" : undefined,
                    }}
                  >
                    {formValue}
                  </Typography>
                )}

                {openSearchButton && (
                  <Select
                    disabled={gaugeInit}
                    value={formValue}
                    onChange={formOptionChange}
                    label="Form"
                    className="input-value"
                  >
                    {formType.length ? (
                      formType.map((item) => {
                        return (
                          <MenuItem key={item.key} value={item.form}>
                            <Typography variant="h1LatoSemiBold">
                              {item.form}
                            </Typography>
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem value={0}>None</MenuItem>
                    )}
                  </Select>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              sx={{ padding: "3%" }}
              xs={matchesMinWidth ? 4 : 12}
              sm={4}
              id="dosageField"
              py={matchesMinWidth ? 1.5 : 4}
              px={matchesMinWidth ? 1 : 4}
            >
              <FormControl variant="standard" sx={{ width: "100%" }}>
                <InputLabel
                  sx={{
                    "-webkit-transform": " translate(0, -1.5px) scale(0.75)",
                  }}
                >
                  <Typography variant="h1LatoMedium">Strength</Typography>
                </InputLabel>

                {!openSearchButton && (
                  <Typography
                    component={"div"}
                    variant="h1LatoSemiBold"
                    eleme
                    sx={{
                      marginTop: "24px",
                      color: "#083d4c",
                    }}
                    className="truncate"
                  >
                    {dosageValue}
                  </Typography>
                )}
                {openSearchButton && (
                  <Select
                    disabled={gaugeInit}
                    value={dosageValue}
                    onChange={dosageChange}
                    label="Dosage"
                    className="input-value"
                  >
                    {dosageTypes.length ? (
                      dosageTypes.map((item) => {
                        return (
                          <MenuItem key={item.dosage} value={item.dosage}>
                            <Typography variant="h1LatoSemiBold">
                              {item.dosage}
                            </Typography>
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem value={0}>None</MenuItem>
                    )}
                  </Select>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              sx={{ paddingBottom: matchesMinWidth ? "3%" : "0%" }}
              xs={matchesMinWidth ? 4 : 12}
              sm={4}
              id="quantityField"
              py={matchesMinWidth ? 1.5 : 4}
              px={matchesMinWidth ? 1 : 4}
            >
              <FormControl variant="standard" sx={{ width: "100%" }}>
                <InputLabel
                  sx={{
                    "-webkit-transform":
                      " translate(0, -1.5px) scale(0.75) !important",
                  }}
                >
                  <Typography variant="h1LatoMedium">Quantity</Typography>
                </InputLabel>
                {!openSearchButton && (
                  <Typography
                    component={"div"}
                    variant="h1LatoSemiBold"
                    eleme
                    sx={{
                      height: "40px",
                      marginTop: "24px",
                      color: "#083d4c",
                    }}
                  >
                    {quantityObj.quantity}{" "}
                    {quantityObj.isCustomQuantity && "(Custom Qty)"}
                  </Typography>
                )}
                {openSearchButton && (
                  <Select
                    disabled={gaugeInit}
                    value={quantityValue}
                    onChange={quantityChange}
                    label="Quantity"
                    className="input-value"
                  >
                    {quantityTypes.length ? (
                      quantityTypes.map((item) => {
                        return (
                          <MenuItem
                            key={item.productDetailId}
                            onClick={(event) => {
                              if (item.isCustomQuantity) {
                                // quantityChange(item)
                                setShowCustomQuantity(true);
                                event.preventDefault();
                              }
                            }}
                            value={item.productDetailId}
                          >
                            <Typography variant="h1LatoSemiBold">
                              {item.quantity === 99999 ? (
                                "Custom Quantity"
                              ) : item.isCustomQuantity ? (
                                <span>{item.quantity} (Custom Qty)</span>
                              ) : (
                                item.quantity
                              )}
                            </Typography>
                          </MenuItem>
                        );
                      })
                    ) : (
                      <MenuItem value={0}>None</MenuItem>
                    )}
                  </Select>
                )}
              </FormControl>
            </Grid>
            <Grid
              sx={{
                padding: matchesMinWidth ? "3% 0% 3% 3%" : "0% 3% 3% 3%",
              }}
              item
              xs={12}
              sm={8}
              id="insuranceField"
              py={matchesMinWidth ? 1.5 : 4}
              px={matchesMinWidth ? 1 : 4}
            >
              <FormControl variant="standard" sx={{ width: "100%" }}>
                <InputLabel
                  sx={{
                    transform: "translate(0, -5px) scale(1) !important",
                  }}
                >
                  <Typography variant="h1LatoMedium">Insurance</Typography>
                </InputLabel>
                {!openSearchButton && (
                  <Typography
                    component={"div"}
                    variant="h1LatoSemiBold"
                    eleme
                    sx={{
                      height: "40px",
                      marginTop: "24px",
                      color: "#083d4c",
                    }}
                  >
                    {selectedInsurance.name}
                  </Typography>
                )}
                {openSearchButton && (
                  <Input
                    onClick={() => {
                      if (!gaugeInit) {
                        openInsurance("insurance");
                        document.getElementById("appcontent").scroll(0, 0);
                      }
                    }}
                    value={selectedInsurance.name}
                    className="input-value"
                    sx={{
                      "& .Mui-disabled": {
                        WebkitTextFillColor: gaugeInit
                          ? "rgba(0, 0, 0, 0.38)"
                          : "#003D4C",
                      },
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {!gaugeInit && (
                          <IconButton edge="end">
                            <Edit
                              sx={{ color: theme.palette.secondary.main }}
                            />
                          </IconButton>
                        )}
                      </InputAdornment>
                    }
                  />
                )}
              </FormControl>
            </Grid>
            <Grid
              sx={{
                paddingTop: matchesMinWidth ? "3%" : "0%",
                paddingBottom: matchesMinWidth ? "3%" : "0%",
              }}
              item
              xs={12}
              id="zipCodeField"
              sm={4}
              py={matchesMinWidth ? 1.5 : 3.8}
              px={matchesMinWidth ? 1 : 4}
              className="zipcode-input-label"
            >
              <FormControl variant="standard" sx={{ width: "100%" }}>
                {!openSearchButton && (
                  <>
                    <InputLabel
                      sx={{
                        transform: "translate(0, -5px) scale(1) !important",
                      }}
                    >
                      <Typography variant="h1LatoMedium">
                        {locationType === "manual"
                          ? "Zip Code"
                          : "Current Location"}
                      </Typography>
                    </InputLabel>
                    <Typography
                      component={"div"}
                      variant="h1LatoSemiBold"
                      eleme
                      sx={{
                        height: "40px",
                        marginTop: "24px",
                        color: "#083d4c",
                      }}
                    >
                      {locationType === "manual" && (
                        <>{storedZipData?.zipCode}</>
                      )}
                      {locationType === "current_location" &&
                        zipData?.zipCode && (
                          <>
                            {currentLocation?.locality},{" "}
                            {currentLocation?.administrative_area}
                          </>
                        )}
                    </Typography>
                  </>
                )}
                {openSearchButton && (
                  <Field
                    name="zipCode"
                    inputRef={zipInputRef}
                    onChange={zipSearch}
                    component={renderCustomTextField}
                    onBlur={() => {
                      insuranceRef?.current?.focus();
                    }}
                    id="zipcode-textbox"
                    onFocus={(e) => {
                      if (
                        e?.relatedTarget?.id === "zipcode-btn" &&
                        currentLocation !== null
                      ) {
                        setZipCodeUpdateDialog(true);
                      }
                    }}
                    disabled={locationType === "current_location" || gaugeInit}
                    label={
                      locationType === "manual"
                        ? "Zip Code"
                        : "Current Location"
                    }
                    normalize={zipNormalizer}
                    validate={zipValidator}
                    // className="input-value"
                    endIcon={
                      <InputAdornment position="end">
                        {" "}
                        {!gaugeInit && (
                          <IconButton
                            onClick={() => {
                              setZipCodeUpdateDialog(true);
                            }}
                            edge="end"
                          >
                            <Edit
                              sx={{ color: theme.palette.secondary.main }}
                            />
                          </IconButton>
                        )}
                      </InputAdornment>
                    }
                  />
                )}
              </FormControl>
            </Grid>
            {!openSearchButton && (
              <Grid
                item
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  paddingTop: matchesMinWidth ? "0%" : "0%",
                  paddingBottom: matchesMinWidth ? "3%" : "2%",
                }}
                xs={12}
                sm={12}
                py={matchesMinWidth ? 1.5 : 4}
                px={matchesMinWidth ? 1 : 1}
              >
                <Button
                  // disabled={gaugeInit}
                  variant="largeOutline"
                  id="getSavingsBtn"
                  onClick={() => {
                    setGaugeInit(false);
                    setOpenSearchButton(true);
                    setSavingsBtnAutoForward(false);
                  }}
                  style={{
                    minWidth: matchesMinWidth ? "280px" : undefined,
                    // backgroundColor:
                    //   gaugeInit || searchButton ? "#fff" : "#83d712",
                  }}
                >
                  CHANGE SEARCH SETTINGS
                </Button>
              </Grid>
            )}

            {openSearchButton && (
              <Grid
                item
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  padding: "2%",
                  "padding-bottom": matchesMinWidth ? "7%" : "5%",
                }}
                xs={12}
                sm={12}
                py={matchesMinWidth ? 1.5 : 4}
                px={matchesMinWidth ? 1 : 4}
              >
                <Grid
                  sx={{
                    width: "500px",
                    textAlign: "center",
                  }}
                  item
                  xs={12}
                >
                  <Box
                    sx={{
                      height: "70%",
                    }}
                  >
                    <Button
                      disabled={gaugeInit || searchButton}
                      variant="large"
                      id="getSavingsBtn"
                      onClick={() => {
                        if (gaugeReset) {
                          resetData("quantityReset");
                        }
                        setGaugeInit(gaugeReset);
                        setSearchButton(true);
                        setOpenSearchButton(false);
                        setInsuraceChange(false);
                        setZipCodeChange(false);
                        setTempFormValue({});
                        setGaugeReset(false);
                        setSavingsBtnAutoForward(true);
                        setEditFromInsurace(false);
                      }}
                      sx={{
                        minWidth: 330,
                        fontFamily: "Lato-Bold",
                        color:
                          gaugeInit || searchButton
                            ? `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`
                            : `${organizationInfo?.colorSchemeJson?.primaryButtonTextColor} !important`,
                        backgroundColor:
                          gaugeInit || searchButton
                            ? `${organizationInfo?.colorSchemeJson?.otherButtonColor}`
                            : `${organizationInfo?.colorSchemeJson?.primaryButtonColor}`,
                      }}
                    >
                      DONE
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      // disabled={!searchButton}
                      variant="large"
                      sx={{
                        minWidth: 330,
                        fontFamily: "Lato-Bold",
                        color: `${organizationInfo?.colorSchemeJson?.otherButtonTextColor}  !important`,
                        backgroundColor: `${organizationInfo?.colorSchemeJson?.otherButtonColor}`,
                      }}
                      onClick={(event) => {
                        if (!searchButton) {
                          resetForm(event);
                          setTimeout(
                            () => {
                              // setGaugeInit(gaugeReset);

                              setSearchButton(true);
                            },
                            zipCodeChange ? 1000 : 0
                          );
                        }
                        if (editFromInsurace) {
                          setShowGauge(false);
                        }
                        setOpenSearchButton(false);
                        setGaugeReset(false);
                        if (
                          !genericDetails?.adjudicationId &&
                          !brandDetailsNew?.adjudicationId
                        ) {
                          setSavingsBtnAutoForward(true);
                        }
                      }}
                    >
                      CANCEL
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Grid>
        </form>
      ) : null}
      <ZipcodeErrorMsg initialize={props.initialize} />

      {showDiscountError && (
        <Dialog open={showDiscountError} className="info-dialog">
          <DialogContent
            sx={{
              paddingLeft: matchesMinWidth ? "24px" : "40px",
              paddingRight: matchesMinWidth ? "24px" : "40px",
            }}
          >
            <Box mt={2}>
              <Typography variant="text4">
                {discountPriceError?.message}
              </Typography>
            </Box>
            <Box mt={3} mb={1}>
              <Button
                sx={{ width: 100 }}
                variant="filled"
                onClick={() => {
                  document.getElementById("appcontent").scroll(0, 0);
                  setShowDiscountError(false);
                  setGaugeInit(false);
                  setOpenSearchButton(true);
                  setSavingsBtnAutoForward(false);
                }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {showRetailError && (
        <Dialog open={showRetailError} className="info-dialog">
          <DialogContent
            sx={{
              paddingLeft: matchesMinWidth ? "24px" : "40px",
              paddingRight: matchesMinWidth ? "24px" : "40px",
            }}
          >
            <Box mt={2}>
              <Typography variant="text4">
                {retailDataError?.message}
              </Typography>
            </Box>
            <Box mt={3} mb={1}>
              <Button
                sx={{ width: 100 }}
                variant="filled"
                onClick={() => {
                  document.getElementById("appcontent").scroll(0, 0);
                  setShowRetailError(false);
                  setGaugeInit(false);
                  setOpenSearchButton(true);
                  setSavingsBtnAutoForward(false);
                }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {openZipCodeUpdateDialog ? (
        <Dialog open={openZipCodeUpdateDialog} className="info-dialog">
          <DialogContent
            sx={{
              paddingLeft: matchesMinWidth ? "20px" : "60px",
              paddingRight: matchesMinWidth ? "20px" : "60px",
            }}
          >
            <Box sx={{ display: "grid", textAlign: "left" }} mt={2}>
              <Typography
                sx={{ opacity: currentLocation === null ? 0.5 : 1 }}
                variant="text4"
              >
                <Radio
                  sx={{
                    color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                  }}
                  disabled={currentLocation === null}
                  {...radioControlProps("current_location")}
                  color="success"
                />
                Current Location
                {currentLocation === null && (
                  <Tooltip
                    placement="top"
                    title="Please provide the location permission and refresh"
                    arrow
                  >
                    <Info sx={{ top: "5px", position: "relative" }} />
                  </Tooltip>
                )}
              </Typography>
              <Typography variant="text4">
                <Radio
                  sx={{
                    color: `${organizationInfo?.colorSchemeJson?.primaryButtonColor} !important`,
                  }}
                  {...radioControlProps("manual")}
                  color="success"
                />
                Zip Code
              </Typography>
            </Box>
            <Box mt={3} mb={1}>
              <Button
                sx={{ width: 100 }}
                variant="filled"
                onClick={() => {
                  setZipCodeUpdateDialog(false);
                  localStorage.setItem("zip_location_type", locationTypeTemp);
                  setlocationType(locationTypeTemp);
                  setSearchButton(false);
                  setZipCodeChange(true);
                  setGaugeReset(true);
                  // document.getElementById("appcontent").scroll(0, 0);
                  // setShowZipcodeError(false);
                  // props.initialize({
                  //   zipCode: storedZipData?.zipCode || "",
                  // });
                }}
              >
                OK
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      ) : null}

      {showCustomQuantity ? (
        <Dialog open={showCustomQuantity} className="app-dialog">
          <DialogContent sx={{ padding: matchesMinWidth ? "24px" : "40px" }}>
            <form onSubmit={onEnterCustomValue}>
              <Box sx={{ marginBottom: matchesMinWidth ? "60px" : "80px" }}>
                <FormControl variant="standard" sx={{ width: "100%" }}>
                  <TextField
                    variant="standard"
                    focused
                    required
                    value={customQuantity}
                    label={`${
                      "Enter a custom quantity between " +
                      getMin(
                        quantityTypes[0]?.quantity,
                        dosageTypeVal.toLocaleLowerCase() === "o" ? 0.001 : 1
                      ) +
                      " and " +
                      getMax(
                        quantityTypes[quantityTypes.length - 2]?.quantity,
                        dosageTypeVal.toLocaleLowerCase() === "o"
                          ? 999.999
                          : 999
                      )
                    }`}
                    type="number"
                    onChange={(event) => {
                      let value = Number(event.target.value);
                      if (
                        dosageTypeVal.toLocaleLowerCase() === "t" ||
                        dosageTypeVal.toLocaleLowerCase() === "c"
                      ) {
                        value = value?.toFixed(0);
                      }
                      setCustomQuantity(value);
                    }}
                    InputProps={{
                      inputProps: {
                        inputMode: "numeric",
                        step: getMin(
                          quantityTypes[0]?.quantity,
                          dosageTypeVal.toLocaleLowerCase() === "o" ? 0.001 : 1
                        ),
                        min: getMin(
                          quantityTypes[0]?.quantity,
                          dosageTypeVal.toLocaleLowerCase() === "o" ? 0.001 : 1
                        ),
                        max: getMax(
                          quantityTypes[quantityTypes.length - 2]?.quantity,
                          dosageTypeVal.toLocaleLowerCase() === "o"
                            ? 999.999
                            : 999
                        ),
                      },
                    }}
                  />
                </FormControl>
              </Box>
              <Box my={2}>
                <Button
                  type="submit"
                  mb={5}
                  variant="large"
                  sx={{
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                  }}
                >
                  DONE
                </Button>
              </Box>
              <Box>
                <Button
                  variant="text"
                  onClick={() => {
                    setShowCustomQuantity(false);
                  }}
                  sx={{
                    width: matchesMinWidth ? undefined : "100%",
                    fontSize: matchesMinWidth ? "14px" : undefined,
                    minWidth: matchesMinWidth ? "200px" : undefined,
                  }}
                >
                  CANCEL
                </Button>
              </Box>
            </form>
          </DialogContent>
        </Dialog>
      ) : null}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    isProgress: state.productDetails.isProgress,
    productDetails: state.productDetails.data,
    selectedInsurance: state.insuranceList.selectedInsurance,
    selectedProduct: state.home.selectedProduct,
    selectedDosage: state.home.selectedDosage,
    zipData: state.zipData.data,
    gtmInfo: state.gtmInfo.data,
    currentLocation: state.zipData.currentLocation,
    retailData: state.retailPrice.data,
    discountData: state.discountPrice.data,
    retailMessage: state.retailPrice.message,
    hasUserSelectedInsurance: state.insuranceList.hasUserSelectedInsurance,
    copayPrice: state.copayPrice.data,
    organizationInfo: state.organizationInfo.data || {},
    brandDetailsNew: state.brandDetailsNew.data,
    genericDetails: state.genericDetails.data,
    retailDataError: state.retailPrice.error,
    retailDataIsSuccess: state.retailPrice.success,
    retailDataisProgress: state.retailPrice.isProgress,
    discountPriceError: state.discountPrice.error,
    discountPriceIsSuccess: state.discountPrice.success,
    discountPriceisProgress: state.discountPrice.isProgress,
  };
};

const mapDispatchToProps = {
  getCityStateForZipCode: (value) => homeActions.getCityStateForZipCode(value),
  saveInsuranceData: (value) => homeActions.saveInsuranceData(value),
  resetData: (value) => homeActions.resetData(value),
  saveDosage: (value) => homeActions.saveDosage(value),
  saveForm: (value) => homeActions.saveForm(value),
  saveQuantity: (value) => homeActions.saveQuantity(value),
  saveZipCodeToServer: (value) => homeActions.saveZipCodeToServer(value),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  savedevicelocation: (currentLocation) =>
    homeActions.savedevicelocation(currentLocation),
  saveCurrentLocationData: (data) => homeActions.saveCurrentLocationData(data),
  saveUserInsurance: (value) => homeActions.saveUserInsurance(value),
};

const ProductDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductDetailsView);

export default reduxForm({
  form: "PRODUCT_DETAILS",
})(ProductDetails);
